import { isEmptyObject } from "../../../utils/tests";
import { LmpMatchChangeQuery, LmpMatchChangeSubscription } from '../types';

/**
 * typeguard for LmpMatchChangeQuery
 * @param LmpMatchChangeQuery object passed to transformer
 */
export const isValidLmpMatchChange = (obj: LmpMatchChangeQuery): boolean => Boolean(obj?.data?.getLmpMatchChange && !isEmptyObject(obj.data.getLmpMatchChange));


/**
 * typeguard for LmpMatchChangeSubscription
 * @param LmpMatchChangeSubscription object passed to transformer
 */
export const isValidLmpMatchChangeSubscription = (obj: LmpMatchChangeSubscription): boolean => Boolean(obj?.data?.onUpdateLmpMatchChangeByMatchId && !isEmptyObject(obj.data.onUpdateLmpMatchChangeByMatchId));
